import NotificationsPaneContainer from './notifications-pane-container';

export default NotificationsPaneContainer;
